import { PdfTourPage1 } from './pages/PdfProjectTourP1';
import { PdfTourPage2 } from './pages/PdfProjectTourP2';
import { PdfTourPage3 } from './pages/PdfProjectTourP3';
import { PdfTourPage4 } from './pages/PdfProjectTourP4';
import { PdfTourPage5 } from './pages/PdfProjectTourP5';

export function PdfProjectTour() {
  const totalPages: number = 5;

  return (
    <>
      <PdfTourPage1 totalPages={totalPages} />
      <PdfTourPage2 totalPages={totalPages} />
      <PdfTourPage3 totalPages={totalPages} />
      <PdfTourPage4 totalPages={totalPages} />
      <PdfTourPage5 totalPages={totalPages} />
    </>
  );
}
